import React, { FC } from 'react';
import { MotifLabel } from 'assets/lib';

type LabelProps = {
    id?: string;
    text?: string;
    children?: React.ReactNode;
    style?: any;
    className?: string;
};
const Label: FC<LabelProps> = ({ id, text, style, className }: LabelProps) => (
    <MotifLabel id={id} style={style} className={className}>
        {text}
    </MotifLabel>
);

export default Label;
